import Link from 'components/Link'
import SatisfactionGuaranteedSeal from 'components/SatisfactionGuaranteedSeal'
import * as contentStyles from '../../styles/content.module.css'

const HappinessGuaranteeView = () =>
  <div className={contentStyles.contentView}>
    <div className={contentStyles.contentTitleRow}>
      <h1>Happiness Guarantee</h1>
    </div>
    <br />
    <div className={contentStyles.floatLeft}>
      <SatisfactionGuaranteedSeal width={180} height={180} />
    </div>
    <p>We are <strong>obsessed</strong> with your happiness. But, like, in a totally healthy way.</p>
    <p>Way deep down inside, we believe that we offer something better. And we think you’ll agree. Because of that, we guarantee your happiness with our service, no matter what. <strong>We will try our absolute best to make you happy, and if we can’t we will give you your money back</strong>. No <i>ifs</i>, <i>ands</i>, or <i>buts</i> about it.</p>
    <p>Sometimes trying new things means taking a risk, but not this. <Link href='/'>Learn more about CardHero</Link> or <Link href='/bundles'>give us a try</Link> now.</p>
  </div>

export default HappinessGuaranteeView
